import React, { useCallback, useEffect, useRef, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { IoIosSwitch } from 'react-icons/io';
import { Button } from '@mui/material';
import createNotification from 'src/components/common/NotificationContainer';
import { getCommonHeaderGetAndPost } from 'src/context/actions/global_search';
import Board from '@asseinfo/react-kanban'
import '@asseinfo/react-kanban/dist/styles.css'
import { ArrowDropDown } from '@material-ui/icons'


const DragToSortDropdown = (props) => {

const {
    board,
    setBoard,handleClickResetsortableHeading,
    headerType,
    dragCardInitData=null
}= props

    // Function to handle sorting
    const [isOpen, setisOpen] = useState(false)
    const dropdownRef = useRef(null);

    const handleCheckboxChange = (id) => {
        const updatedColumns = board.columns.map((column) => ({
            ...column,
            cards: column.cards.map((card) =>
                card.id === id ? { ...card, checked: !card.checked } : card
            ),
        }));
        setBoard({ columns: updatedColumns });
    };

    const getOrSaveOrder = useCallback((isGet=false) => {
        const headers = board?.columns[0]?.cards
        const data = isGet?{header_type:headerType}:{headers,header_type:headerType}
        getCommonHeaderGetAndPost(data)(response => {
            if (response.data?.status === true) {
                !isGet&&createNotification('Success', 'Order Saved Successfully');
                if(response?.data?.headers.length>0&&isGet===true){
                    const currentTableIds = dragCardInitData?.map(item=>item?.id)
                    const mergedHeaderData = currentTableIds?.length>0?response?.data?.headers?.filter(item=>currentTableIds.includes(item?.id)):response?.data?.headers
                    setBoard({
                        columns: [
                            {
                                id: 1,
                                cards: [
                                    ...mergedHeaderData
                                ],
                            },
                        ],
                    })

                }
            } else {
                !isGet&&createNotification('error', 'Error while saving order');
            }
        })
        !isGet&&openDropdown()
    },[board])

    const openDropdown = () => {
        setisOpen(!isOpen)
    }

    useEffect(()=>{
        getOrSaveOrder(true)
    },[])
    const renderCard = useCallback((card, { dragging }) => {
        return (
            <div
                className={`dropdown-item ${dragging ? "dragging" : ""}`}
                style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                    cursor: "move",
                    marginBottom: "8px",
                }}
            >
                <div className="form-check">
                    <input
                        type="checkbox"
                        className="form-check-input checkbox"
                        checked={card.checked || false}
                        onChange={() => handleCheckboxChange(card.id)}
                        id={`card-${card.id}`}
                        style={{ color: "#1ba1a6", borderColor: "#1ba1a6" }}
                    />
                    <label className="form-check-label" htmlFor={`card-${card.id}`}>
                        {card.label}
                    </label>
                </div>
            </div>
        );
    }, [board]);

    const onCardDragEnd = (card, source, destination) => {
        if (!destination) {
            // If the card is dropped outside any valid column, do nothing
            return;
        }

        // Create a copy of the board to modify
        const updatedColumns = board.columns.map((column) => {
            // Clone the cards array to avoid mutating state directly
            const cards = [...column.cards];

            // Remove the card from the source position
            if (column.id === source.fromColumnId) {
                cards.splice(source.fromPosition, 1);
            }

            // Add the card to the destination position
            if (column.id === destination.toColumnId) {
                cards.splice(destination.toPosition, 0, {
                    ...card,
                    checked: card.checked || false, // Ensure `checked` is defined
                });
            }

            return { ...column, cards };
        });

        // Update the board state
        setBoard({ columns: updatedColumns });
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setisOpen(false); // Close dropdown if clicking outside
        }
    };

    useEffect(() => {
        // Add click event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Cleanup on component unmount
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (
        <Tooltip disableInteractive title="Table Headings" placement="top" arrow>
            <div className="dropdown ms-2" ref={dropdownRef}>
                <Button
                    size='medium'
                    className='mt-2 me-2 '
                    variant="outlined"
                    type="button"
                    onClick={openDropdown}
                    style={{ color: "#1ba1a6", borderColor: '#1ba1a6' }}
                    startIcon={<IoIosSwitch className="jobMonitor-svg" />}
                >
                    <ArrowDropDown/>
                </Button>
                {isOpen && <ul
                    className="encounder-search-heading-dropdown"
                    style={{ overflowY: 'auto', padding: '8px' }}
                    onClick={(e) => e.stopPropagation()}

                >
                    <Board
                        allowAddCard
                        onCardDragEnd={onCardDragEnd}
                        renderCard={renderCard}
                    // initialBoard={board}
                    >{board}</Board>
                   
                        <Button onClick={handleClickResetsortableHeading} size='medium' className='mt-2 ms-2 text-secondary border-secondary' variant="outlined"   >Reset</Button>
                        <Button onClick={()=>getOrSaveOrder(false)} size='medium' className='mt-2 ms-2' variant="outlined" style={{ color: "#1ba1a6", borderColor: '#1ba1a6',  }} >Store Preference</Button>
                    
                </ul>}
            </div>
        </Tooltip>
    );
};

export default React.memo(DragToSortDropdown);
